export default __webpack_public_path__ + "static/media/0920 Kana and Vero_54.86002986.jpg";